
import { z } from "zod";

export const PermittingEntityValues = ["CONTRACTOR", "REMI"] as const;
export const PermittingEntitySchema = z.enum(PermittingEntityValues);
export const PermittingEntity = PermittingEntitySchema.enum;
export type PermittingEntity = (typeof PermittingEntityValues)[number];
export const PermittingEntityDisplayNames = { "CONTRACTOR": "Contractor",
"REMI": "Remi", } satisfies Record<PermittingEntity, string>;
